import { useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";

export function useToolpadRouter() {
  const navigate = useNavigate();
  const location = useLocation();

  const router = useMemo(() => {
    return {
      pathname: location.pathname,
      searchParams: new URLSearchParams(location.search),
      navigate: (to) => navigate(to),
    };
  }, [navigate, location]);

  return router;
}
